export default __webpack_public_path__ + "80dfbc886170882dab8e887abff992e7.png";